<template>
  <!-- NOTE (TEMPLATE) to build a general proposal and use it in the project as a component -->

  <div class="animated fadeIn accelerator-requests" v-if="pageLoaded">
    <b-card style="border: 0" class="mt-0 mb-0 common-card">
      <h3>کد نخبه: {{ proposal.requestsCode }}</h3>
      <h4 class="text-dark">وضعیت نخبه: {{ proposal.status }}</h4>
      <hr />
      <v-btn
        class="float-end bc-purple text-capitalize"
        elevation="0"
        v-if="tabIndex == 0"
        variant="primary"
        @click="saveDocx('doc')"
      >
        <i class="fa fa-file-word-o white--text pe-1"></i>
        <span class="white--text"> دریافت Word</span>
      </v-btn>
      <!-- docx -->
      <div v-show="false" id="doc">
        <div class="all" style="text-align: right">
          <h1
            style="
              display: inline-block;
              text-align: center;
              padding: 5px 0;
              border-bottom: 3px solid black;
            "
          >
            کد نخبه وظیفه:
            <span style="direction: ltr; font-family: Bahnschrift SemiBold">{{
              proposal.researcherEliteCode
            }}</span>
          </h1>
          <div>
            <h2 style="color: black; direction: rtl">
              تاریخ خروجی: {{ exportDate }}
            </h2>
            <hr />
            <h2 style="display: inline-block; text-align: center; color: blue">
              عنوان و درخواست‌های پیشین
            </h2>
            <div>
              <ul>
                <li :class="proposal.initialIsSupported ? 'done' : 'required'">
                  <strong
                    >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده
                    کرده است؟
                  </strong>

                  {{ proposal.initialIsSupported ? "بله" : "خیر" }}
                </li>

                <li
                  v-if="proposal.initialIsSupported"
                  :class="proposal.initialSupportedType ? 'done' : 'required'"
                >
                  <strong> حمایت ها: </strong
                  >{{
                    proposal.initialSupportedType
                      ? options.filter(
                          (x) => x.value == proposal.initialSupportedType
                        )[0].text
                      : ""
                  }}
                </li>
                <li
                  v-if="
                    proposal.initialSupportedType == 'other' &&
                    proposal.initialIsSupported
                  "
                  :class="proposal.initialOtherSupport ? 'done' : 'required'"
                >
                  <strong>عنوان حمایت دریافتی: </strong>
                  {{ proposal.initialOtherSupport }}
                </li>
                <li
                  v-if="proposal.initialIsSupported"
                  :class="
                    proposal.initialSupportDescription ? 'done' : 'required'
                  "
                >
                  <strong>توضیحات حمایت دریافتی: </strong>
                  {{ proposal.initialSupportDescription }}
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات نخبه وظیفه‌
            </h2>
            <ul>
              <li
                :class="
                  proposal.researcherBachelorSubject ? 'done' : 'required'
                "
              >
                <strong>عنوان پروژه کارشناسی: </strong
                >{{ proposal.researcherBachelorSubject }}
              </li>
              <li
                :class="
                  proposal.researcherMasterThesisSubject ? 'done' : 'required'
                "
              >
                <strong>عنوان پروژه کارشناسی ارشد: </strong
                >{{ proposal.researcherMasterThesisSubject }}
              </li>
              <li>
                <strong>رساله دکتری: </strong
                >{{ proposal.researcherPhDThesisSubject }}
              </li>
              <li>
                <strong>آخرین مدرک تحصیلی: </strong
                >{{ proposal.researcherLastDegree }}
              </li>
              <li :class="proposal.researcherEliteCode ? 'done' : 'required'">
                <strong>کد نخبگی: </strong>{{ proposal.researcherEliteCode }}
              </li>
              <li :class="proposal.universityId ? 'done' : 'required'">
                <strong>دانشگاه محل اجرای طرح جایگزین خدمت: </strong>
                {{
                  proposal.universityId
                    ? universities.filter(
                        (x) => x.id == proposal.universityId
                      )[0]
                      ? universities.filter(
                          (x) => x.id == proposal.universityId
                        )[0].text
                      : "-"
                    : "-"
                }}
              </li>
              <li
                v-if="proposal.universityId == notUniversity"
                :class="proposal.otherUniversity ? 'done' : 'required'"
              >
                <strong>نام دانشگاه: </strong>{{ proposal.otherUniversity }}
              </li>
              <li
                v-if="proposal.mehvarId != notMehvar"
                :class="proposal.mehvarId ? 'done' : 'required'"
              >
                <strong>محور طرح جایگزین خدمت: </strong>
                {{
                  proposal.mehvarId
                    ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                      ? mehvars.filter((x) => x.id == proposal.mehvarId)[0].text
                      : ""
                    : ""
                }}
              </li>
              <li
                v-if="proposal.mehvarId == notMehvar"
                :class="proposal.mehvarId ? 'done' : 'required'"
              >
                <strong> محور طرح جایگزین خدمت: </strong>سایر محورها
              </li>
              <li
                v-if="proposal.mehvarId == notMehvar"
                :class="proposal.otherMehvars ? 'done' : 'required'"
              >
                <strong>نام محور: </strong>{{ proposal.otherMehvars }}
              </li>
              <li>
                <strong>حوزه طرح جایگزین خدمت: </strong>
                <ul>
                  <li v-if="proposal.zoneMedicine">پزشکی</li>
                  <li v-if="proposal.zoneAgriculture">کشاورزی</li>
                  <li v-if="proposal.zoneEnvironment">محیط زیست</li>
                  <li v-if="proposal.zoneIndustrial">صنعتی</li>
                  <li v-if="proposal.zoneBioComputing">رایانش زیستی</li>
                  <li v-if="proposal.zoneOther">سایر</li>
                </ul>
              </li>
              <li>
                <strong>وضعیت تاهل: </strong>
                {{
                  proposal.researcherMartialStatus == "single"
                    ? "مجرد"
                    : "متاهل"
                }}
              </li>

              <li v-if="proposal.researcherMartialStatus == 'married'">
                <strong>تعداد فرزند: </strong
                >{{
                  proposal.researcherChildrenNumber &&
                  !proposal.researcherNotChildren
                    ? proposal.researcherChildrenNumber
                    : "فرزند ندارم"
                }}
              </li>
            </ul>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              مشخصات طرح
            </h2>
            <div>
              <ul>
                <li :class="proposal.abstract ? 'done' : 'required'">
                  <strong>چکیده دوره: </strong><br />
                  {{ proposal.abstract }}
                </li>
                <li :class="proposal.requestNecessity ? 'done' : 'required'">
                  <strong
                    >ضرورت اجرای دوره (در جهت دستیابی به اهداف ستاد و یا
                    راهبردها و اقدامات سند توسعه زیست فناوری): </strong
                  ><br />
                  {{ proposal.requestNecessity }}
                </li>
                <li :class="proposal.majorGoals ? 'done' : 'required'">
                  <strong>اهداف کلان دوره: </strong><br />
                  {{ proposal.majorGoals }}
                </li>
                <li :class="proposal.minorGoals ? 'done' : 'required'">
                  <strong>اهداف خرد دوره: </strong><br />
                  {{ proposal.minorGoals }}
                </li>
                <li :class="proposal.benefitsToCountry ? 'done' : 'required'">
                  <strong>مزایای دیگر برای کشور: </strong><br />
                  {{ proposal.benefitsToCountry }}
                </li>
                <li :class="proposal.methodology ? 'done' : 'required'">
                  <strong>روش شناسی (متدولوژی) و مراحل انجام دوره: </strong
                  ><br />
                  {{ proposal.methodology }}
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              زمان‌بندی دوره
            </h2>
            <div>
              <strong>زمان شروع: </strong>
              {{
                proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.min(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.startDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jDD/jMM/jYYYY")
                  : ""
              }}
              <br />
              <strong>زمان پایان: </strong>
              {{
                proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jDD/jMM/jYYYY")
                  : ""
              }}
              <br />
              <strong>مدت زمان: </strong>
              {{
                proposal.gantData.length > 0
                  ? (Math.max(
                      ...proposal.gantData.map((x) =>
                        new Date(
                          moment(x.dueDate, "jYYYY/jMM/jDD").format(
                            "YYYY-MM-DD"
                          )
                        ).getTime()
                      )
                    ) -
                      Math.min(
                        ...proposal.gantData.map((x) =>
                          new Date(
                            moment(x.startDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )) /
                      3600 /
                      24 /
                      1000 +
                    " روز"
                  : ""
              }}
              <br />
            </div>
            <b-table
              responsive
              small
              show-empty
              head-variant="dark"
              :items="proposal.gantData"
              :fields="serviceFieldsDoc"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
            </b-table>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              هزینه‌ها
            </h2>
            <h3>
              <strong>مبلغ حمایت: </strong
              >{{
                Number(proposal.eliteFinancialSupport / 10).toLocaleString()
              }}
              تومان
            </h3>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              تعهدات
            </h2>
            <div>
              <ul>
                <li v-if="proposal.promiseArrays[0]">
                  ارائه به موقع گزارش هر سه ماه یکبار در قالب فرمت پیشنهادی.
                </li>
                <li v-if="proposal.promiseArrays[1]">بارگذرای گزارش سامانه.</li>
              </ul>
            </div>
          </div>
          <hr />
        </div>
      </div>
      <!-- docx -->
      <b-tabs class="mt-8" pills v-model="tabIndex">
        <b-tab title="چکیده طرح" active lazy>
          <Elite
            :proposal="proposal"
            :universities="universities"
            :mehvars="mehvars"
            :isLoaded="isLoaded"
          />
        </b-tab>
        <b-tab title="داوری" active>
          <Review />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import Elite from "./../../components/AcceleratorElite";
import Review from "./../../components/AcceleratorReview";
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("./../../components/sarmadGantt");
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    Select2, // NOTE (COMPONENT) component of select2 plugin
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
    Elite,
    Review,
  },
  data() {
    return {
      refereeErrorHandler: false,
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      oldData: [],
      expireDisable: false,
      statusDictionary: [
        { en: "Done", fa: "تمام" },
        { en: "NotDone", fa: "ناتمام" },
        { en: "Expired", fa: "منقضی" },
      ],
      rejectCause: [],
      rejectOptions: [],
      infoo: "",
      promises: {},
      uploadedFiles: [],
      fileBusy: true,
      selectedStatus: null,
      selectedSituation: "",
      comments: "",
      adminToReferee: "",
      reviewersData: [],
      reviewersFields: [],
      judgements: [],
      selectedJudgement: {},
      journalsFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام" },
        { key: "message", label: "پیام" },
        { key: "date", label: "تاریخ" },
      ],
      judgementFields: [
        { key: "index", label: "#" },
        { key: "status", label: "وضعیت" },
        { key: "referee", label: "داور" },
        { key: "decision", label: "تصمیم" },
        { key: "judgeDate", label: "تاریخ داوری" },
        { key: "description", label: "توضیحات" },
      ],
      reviewers: [],
      situationsOptions: [
        { id: 1, eng: "registered", text: "ثبت شده" },
        { id: 2, eng: "underSupervision", text: "درحال بررسی" },
        { id: 3, eng: "inviteReviewers", text: "در دست داوری" },
        { id: 4, eng: "reviewDone", text: "جمع بندی نظرات داوران" },
        { id: 5, eng: "approve", text: "پذیرش اولیه" },
        { id: 6, eng: "corrected", text: "اصلاح شده" },
        { id: 7, eng: "finalAccept", text: "تایید نهایی" },
        { id: 8, eng: "incomplete", text: "نیاز به تکمیل / اصلاح" },
        { id: 9, eng: "reject", text: "رد شده است" },
        { id: 10, eng: "declined", text: "لغو" },
      ],
      selectedReferee: "",
      adminMessage: "",
      reportItems: [],
      reportFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      fileItems: [],
      filesFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      haveReferee: null,
      contract: null,
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌های تخصصی", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],

      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      moment: moment,
      show: false,
      checkbox: "",
      checkbox2: "",
      busy: false,
      initial: {},
      doi: "",
      code: {},
      source: "",
      specs: {},
      rejectMessage: "",
      colleaguesData: [],
      selectedColleague: "",
      executor: {},
      proposal: {
        initialIsSupported: null,
        researcherMartialStatus: null,
        description: "",
      },
      colleague: {},
      universities: [],
      mehvars: [],
      zone: new Array(6).fill(false),
      achievmentitems: [],
      tabIndex: 0,
      proposalStudies: false,
      proposalDevelopment: false,
      proposalPractical: false,
      support: "",
      supportSetad: "",
      dr: {},
      pageLoaded: false,
      selectedMehvar: 0,
      elite: {},
      taahol: "",
      acc: 0,
      isLoaded: true,
    };
  },

  methods: {
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    onMounted() {
      // NOTE (MOUNTED) to show the data of this page
      this.proposal = {
        abstract:
          "وقتی ثروت‌ های بزرگ به دست برخی مردم می‌افتد در پرتو آن نیرومند می‌شوند و در سایهٔ نیرومندی و ثروت خیال می‌ کنند که می‌توانند در خارج از وطن خود زندگی نمایند و خوشبخت و سرافراز باشند ولی به زودی می‌ فهمند که اشتباه کرده‌ اند و عظمت هر ملتی بر روی خرابه‌ های وطن خودش می‌باشد و بس! وقتی ثروت‌ های بزرگ به دست برخی مردم می‌افتد در پرتو آن نیرومند می‌شوند و در سایهٔ نیرومندی و ثروت خیال می‌ کنند که می‌توانند در خارج از وطن خود زندگی نمایند و خوشبخت و سرافراز باشند ولی به زودی می‌ فهمند که اشتباه کرده‌ اند و عظمت هر ملتی بر روی خرابه‌ های وطن خودش می‌باشد و بس!",
        adminMessage: "",
        benefitsToCountry: "مزایا",
        duration: "78",
        eliteFinancialSupport: "14441700",
        fastSub: false,
        finalDate: "1401/02/19",
        gantData: [
          {
            cellColor: "#F44E3B",
            description: "فعالیت‌ها",
            dueDate: "1401/02/19",
            percent: "80",
            startDate: "1400/12/01",
          },
          {
            cellColor: "blue",
            description: "فعالیت‌ها 2",
            dueDate: "1401/02/19",
            percent: "20",
            startDate: "1401/02/18",
          },
        ],
        initialIsSupported: true,
        initialObligation: true,
        initialOtherSupport: "",
        initialSupportDescription:
          "توضیحات برای نخبه به عنوان حمایت دریافت شده!",
        initialSupportedType: "",
        isArchive: false,
        lastUpdated: "",
        majorGoals: "کلان",
        mehvarId: "",
        methodology: "متدولوژی",
        minorGoals: "خرد",
        otherMehvars: "",
        otherUniversity: "",
        promiseArrays: [true, true],
        registerDate: "1401/02/18",
        rejectionIds: [],
        requestNecessity: "ضرورت",
        requestsCode: "biodc-2002154-2002242.2",
        researcherBachelorSubject: "عنوان تستی 1",
        researcherChildrenNumber: 1,
        researcherEliteCode: "1455541",
        researcherLastDegree: "دکتری عمومی",
        researcherMartialStatus: "married",
        researcherMasterThesisSubject: "عنوان تستی 2",
        researcherNotChildren: false,
        researcherPhDThesisSubject: "عنوان تستی 3",
        researcherResumeFile:
          "undefined/setad/private/nokhbe\\6277725de3c2e2252400c53a\\1651995362916customizing-color.pdf",
        researcherResumeFileId: "627772e3e3c2e2252400c6f2",
        revision: "2",
        startDate: "1400/12/01",
        status: "تایید نهایی",
        universityId: "",
        uploadedFiles: [
          {
            id: "627772e3e3c2e2252400c6f2",
            showName: "customizing-color.pdf",
            url: "undefined/setad/private/nokhbe\\6277725de3c2e2252400c53a\\1651995362916customizing-color.pdf",
          },
        ],
        zoneAgriculture: false,
        zoneBioComputing: false,
        zoneEnvironment: false,
        zoneIndustrial: true,
        zoneMedicine: false,
        zoneOther: false,
      };
      this.pageLoaded = true;
      this.fileBusy = false;
      //   this.$bvModal.show("loading");
      //   this.isLoaded = false;
      //   this.$root.$emit("show::modal", "loading");
      //   this.fileBusy = false;
      //     let acc = 0;
      //     // accelerator universities
      //     this.$http
      //       .post(
      //         this.baseUrl + "/setad/options/universities",
      //         {},
      //         {
      //           headers: {
      //             Authorization: "Bearer: " + localStorage.getItem("userId"),
      //           },
      //         }
      //       )
      //       .then((res) => {
      //         this.universities = res.data;
      //         this.universities.push(
      //           new Object({
      //             id: this.notUniversity,
      //             text: "سایر دانشگاه ها",
      //           })
      //         );
      //         this.universities.unshift({
      //           id: 0,
      //           name: "--گزینه مورد نظر خود را انتخاب نمایید--",
      //           disabled: "true",
      //         });
      //         acc++;
      //       })
      //       .catch((err) => {
      //         console.log(err)
      //       });
      //     /////////////////////////////////////////////
      //     // accelerator mehvars
      //     this.$http
      //       .post(
      //         this.baseUrl + "/setad/options/uniMehvars",
      //         {},
      //         {
      //           headers: {
      //             Authorization: "Bearer: " + localStorage.getItem("userId"),
      //           },
      //         }
      //       )
      //       .then((res) => {
      //         this.mehvars = res.data;
      //         acc++;
      //       })
      //       .catch((err) => {
      //         console.log(err)
      //       });
      //     /////////////////////////////////////////////
      //     // accelerator companies
      //     this.$http
      //       .post(
      //         this.baseUrl + "/setad/options/companies",
      //         {},
      //         {
      //           headers: {
      //             Authorization: "Bearer: " + localStorage.getItem("userId"),
      //           },
      //         }
      //       )
      //       .then((res) => {
      //         this.companies = res.data;
      //         this.companies.forEach((x) => {
      //           x.text = x.name;
      //         });
      //         this.companies.push(
      //           new Object({
      //             id: this.notCompany,
      //             text: "سایر شرکت ها",
      //           })
      //         );

      //         acc++;
      //       })
      //       .catch((err) => {
      //         console.log(err)
      //       });
      //     /////////////////////////////////////////////
      //     // accelerator reviewers
      //     this.$http
      //       .post(
      //         this.baseUrl + "/setad/admin/reviewers/select",
      //         {
      //           projectId: this.$route.params.id,
      //         },
      //         {
      //           headers: {
      //             Authorization: "Bearer: " + localStorage.getItem("userId"),
      //           },
      //         }
      //       )
      //       .then((res) => {
      //         this.reviewersOptions = res.data;
      //         this.reviewersOptions.forEach((x) => {
      //           x.code = x.id;
      //           x.label = x.name;
      //         });

      //         acc++;
      //       })
      //       .catch((err) => {
      //         console.log(err)
      //       });
      //     /////////////////////////////////////////////
      //     // accelerator rejections
      //     this.$http
      //       .post(
      //         this.baseUrl + "/setad/options/rejections",
      //         {},
      //         {
      //           headers: {
      //             Authorization: "Bearer: " + localStorage.getItem("userId"),
      //           },
      //         }
      //       )
      //       .then((res) => {
      //         this.rejectOptions = res.data;
      //         this.rejectOptions.forEach((x) => {
      //           x.code = x.id;
      //           x.label = x.name;
      //         });

      //         acc++;
      //       })
      //       .catch((err) => {
      //         console.log(err)
      //       });
      //     //////////////////////////////////////
      //     // accelerator getInfo
      //     this.$http
      //       .post(
      //         this.baseUrl + "/setad/admin/request/opportune/getInfo",
      //         {
      //           requestId: this.$route.params.id,
      //         },
      //         {
      //           headers: {
      //             Authorization: "Bearer: " + localStorage.getItem("userId"),
      //           },
      //         }
      //       )
      //       .then((res) => {
      //         this.proposal = res.data.request;
      //         this.reviews = res.data.reviews;
      //         this.selectedSituation = this.situationsOptions.filter(
      //           (x) => x.text == this.proposal.status
      //         )[0].id;
      //         acc++;
      //         if (acc > 2) {
      //           try {
      //             document.body.classList.toggle("sidebar-minimized");
      //             document.body.classList.toggle("brand-minimized");
      //             this.toast(
      //               "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
      //             );
      //           } catch {}
      //           this.$bvModal.hide("loading");
      //           this.isLoaded = true;
      //         }
      //         setTimeout(() => {
      //           // NOTE (m-setTimeout) to set timeout for 200 ms
      //           this.pageLoaded = true;
      //         }, 200);
      //       })
      //       .catch((err) => {
      //         console.log(err)
      //       });
    },
  },
  computed: {},
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
    this.onMounted();
  },
  updated() {},
};
</script>
<style lang="scss">
.selected-referees {
  border: 1px solid grey;
  border-radius: 5px;
  margin-bottom: 10px;
  &__tags {
    border: 1px solid grey;
    border-radius: 5px;
    padding: 8px 12px;
    .tag {
      padding: 5px;
      margin: 5px;
    }
  }
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.select2 {
  width: 100% !important;
}

select {
  min-width: max-content;
  width: 100%;
}

.required {
  color: red;
}

.done {
  color: green;
}
.btn-dark {
  color: #fff !important;
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  color: #fff !important;
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  color: #fff !important;
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}
#vs1__listbox {
  text-align: right;
  direction: rtl;
}
</style>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
</style>
